/* BARAKA v2: add to cart on scent cards, header cart count, review carousel arrows. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function updateCount() {
    fetch(root + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute("hidden"); else el.setAttribute("hidden", "");
        });
      })
      .catch(function () {});
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-bk-add]");
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest("[data-bk-card]");
    var msg = card ? card.querySelector("[data-bk-msg]") : null;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute("data-adding") || "Adding...";
    if (msg) msg.textContent = "";
    fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute("data-variant")), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        btn.disabled = false;
        btn.textContent = label;
        if (!res.ok) {
          if (msg) msg.textContent = (res.data && (res.data.description || res.data.message)) || "Sorry, we couldn't add this right now.";
          return;
        }
        if (card) card.classList.add("is-added");
        updateCount();
        document.dispatchEvent(new CustomEvent("baraka:cart-updated"));
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        if (msg) msg.textContent = "Sorry, we couldn't add this right now.";
      });
  });

  document.addEventListener("click", function (e) {
    var arrow = e.target.closest("[data-bk-scroll]");
    if (!arrow) return;
    var section = arrow.closest("[data-bk-reviews]");
    var track = section ? section.querySelector("[data-bk-track]") : null;
    if (!track) return;
    var dir = Number(arrow.getAttribute("data-bk-scroll")) || 1;
    track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: "smooth" });
  });
})();
